import BannerIcon from 'components/Content/BannerLayout/BannerIcon/BannerIcon';

export default BannerIcon;
